var _style, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMacro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99 100",
    style: {
      enableBackground: "new 0 0 99 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#52D3FF;}\r\n\t.st1{fill:#F8BE6A;}\r\n\t.st2{fill:#5E63BF;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st0",
    d: "M45.2,54.3l24.7,34.3c-7.2,5.2-15.8,7.9-24.7,7.9C22.1,96.6,3,77.5,3,54.3s19.1-42.2,42.2-42.2 c0.1,0,0.2,0,0.3,0L45.2,54.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st1",
    d: "M48.8,54l40.3,0.3c-0.1,6.3-1.6,12.5-4.4,18.1c-2.9,5.6-7,10.4-12.1,14.2L48.8,54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st2",
    d: "M48.8,50.6L49,3.4c12.5,0,24.5,5,33.3,13.9C91,26.2,96,38.2,96,50.6H48.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.9,40.9L15.9,40.9c0.7,0,1.2,0.5,1.2,1.2v5.3c0,0.3,0.3,0.6,0.6,0.6h0c0.3,0,0.6-0.3,0.6-0.6v-5.3 c0-0.6,0.5-1.2,1.2-1.2h0c0.6,0,1.2,0.5,1.2,1.2v5.3c0,0.3,0.3,0.6,0.6,0.6h0c0.3,0,0.6-0.3,0.6-0.6v-5.3c0-0.6,0.5-1.2,1.2-1.2h0 c0.6,0,1.2,0.5,1.2,1.2v7.3c0,1.5-0.7,2.8-1.7,3.7c-0.9,0.8-1.4,2-1.4,3.2l1,17c0.1,1.5-1.1,2.8-2.6,2.8h-0.1 c-1.5,0-2.7-1.3-2.6-2.8l1-17c0.1-1.2-0.4-2.4-1.4-3.2c-1.1-0.9-1.7-2.2-1.7-3.7v-7.3C14.7,41.5,15.2,40.9,15.9,40.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M37.4,47.6c0-3.7-2.2-6.7-4.8-6.7s-4.8,3-4.8,6.7c0,2.2,0.8,4.2,2,5.4c0.8,0.8,1.2,1.9,1.2,3l-1,17.6 c-0.1,1.5,1.1,2.8,2.6,2.8h0.1c1.5,0,2.7-1.3,2.6-2.8l-1-17.6c-0.1-1.1,0.4-2.2,1.2-3C36.7,51.8,37.4,49.8,37.4,47.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacro);
export default __webpack_public_path__ + "static/media/macro.5884497aacef93f66312e96e5cf5968f.svg";
export { ForwardRef as ReactComponent };